import { render, staticRenderFns } from "./DoctorsPage.vue?vue&type=template&id=51540bda"
import script from "./DoctorsPage.vue?vue&type=script&lang=js"
export * from "./DoctorsPage.vue?vue&type=script&lang=js"
import style0 from "./DoctorsPage.vue?vue&type=style&index=0&id=51540bda&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports